import { fields as formGroupReferralFields } from "./components/FormGroupReferral/fields"

export const fields = {
  financeIof: {
    type: "checkbox",
    name: "finance_iof",
    label: "Financiar IOF"
  },
  ...formGroupReferralFields
}
